import type { DesignSystemIndex } from '../indexer/types.js';
import { attachTastePrimer } from './_taste-primer.js';

export const TOOL_NAME = 'get_positioning';

export const TOOL_DESCRIPTION =
  "Return the brand's positioning document (agent/verbal/positioning.md). Includes a taste primer from magic_trick.md.";

export const INPUT_SCHEMA = {
  type: 'object' as const,
  properties: {},
};

export function handler(index: DesignSystemIndex) {
  const doc = index.verbal.positioning;
  const warnings: string[] = [];

  if (!doc) {
    warnings.push('No positioning document found at agent/verbal/positioning.md');
  }

  const payload = attachTastePrimer(
    {
      content: doc?.body ?? '',
      frontmatter: doc?.frontmatter ?? {},
      source: doc?.source,
      _warnings: warnings,
    },
    index,
  );

  return [{ type: 'text' as const, text: JSON.stringify(payload, null, 2) }];
}
